export const FETCH_DPA_AGREEMENT_REQUEST_PENDING = 'FETCH_DPA_AGREEMENT_REQUEST_PENDING'
export const FETCH_DPA_AGREEMENT_REQUEST_FULFILLED = 'FETCH_DPA_AGREEMENT_REQUEST_FULFILLED'
export const FETCH_DPA_AGREEMENT_REQUEST_REJECTED = 'FETCH_DPA_AGREEMENT_REQUEST_REJECTED'
